/**
 * ? @description : Index Component
 */

// Dependencies
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
// import { BrowserRouter as Router } from "react-router-dom";
import {HashRouter as Router} from "react-router-dom";

// Components
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import store from "./components/redux/app/store";

// CSS
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename="/">
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
